import angular from 'angular';
import { keys, merge } from 'lodash';

module.exports = angular.module('common.routes', [
  require('angular-ui-router'),
  require('angular-scroll'),
  require('common/config/rails'),
])
.config(function($locationProvider, $urlMatcherFactoryProvider) {
  // Fancy pushstate
  $locationProvider.html5Mode({
    enabled: true,
    requireBase: false
  });

  // Allow trailing slashes
  $urlMatcherFactoryProvider.strictMode(false);
})
.run(function($rootScope, $state, $document, Segment) {
  $rootScope.$state = $state;

  $rootScope.$on('$stateChangeStart', function(e, to, params) {
    $rootScope.viewContentLoaded = false;

    Segment.page(to.name);

    // redirectTo
    if (to.redirectTo) {
      e.preventDefault();
      if (typeof(to.redirectTo) === 'object') {
        var state = keys(to.redirectTo)[0];
        $state.go(state, merge({}, params, to.redirectTo[state]));
      } else if (typeof(to.redirectTo) === 'function') {
        $state.go(to.redirectTo(), params);
      } else {
        $state.go(to.redirectTo, params);
      }
    }
  });

  $rootScope.$on('$stateChangeSuccess', function(e, to) {
    // scrollTarget
    if (to.hasOwnProperty('scrollTarget')) {
      if (to.scrollTarget) {
        var target = $document[0].querySelector(to.scrollTarget);
        $document.scrollTo(angular.element(target));
      }
    } else {
      $document.scrollTo(0, 0);
    }

    var remove = $rootScope.$on('$viewContentLoaded', function() {
      $rootScope.viewContentLoaded = true;
      remove();
    });
  });

  $rootScope.$on('$stateChangeError', function(e, to, toParams, from, fromParams, error) {
    throw error;
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/routes/index.js
 **/